// hooks/useCarWashData.ts
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CarDetail, CarDetailState, OrderItem } from "../../home/components/types";
import api from "../../../../../features/auth/axiosConfig";

export const useCarWashData = () => {
  const [orderlist, setOrderList] = useState<OrderItem[]>([]);
  const [categories, setCategories] = useState<CarDetailState[]>([]);
  const [customerData, setCustomerData] = useState<CarDetail>();
  const [activeCategoryId, setActiveCategoryId] = useState<string | null>(null);
  const [filteredProducts, setFilteredProducts] = useState<OrderItem[]>([]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const customerId = searchParams.get("id");

  useEffect(() => {
    fetchData();
  }, []);

  // Update filtered products when orderlist or activeCategoryId changes
  useEffect(() => {
    if (activeCategoryId) {
      filterProductsByCategory(activeCategoryId);
    } else if (orderlist.length > 0) {
      // If no category is selected but we have products, show all products
      setFilteredProducts(orderlist);
    }
  }, [activeCategoryId, orderlist]);

  const fetchData = async () => {
    try {
      await Promise.all([fetchProducts(), fetchCategories(), fetchCustomerData()]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchProducts = async () => {
    const response = await api.get(`/app/v1/pos/product`);
    const userProducts: OrderItem[] = response.data.result;
    setOrderList(userProducts);

    // Initially show all products before any category is selected
    if (userProducts.length > 0) {
      setFilteredProducts(userProducts);
    }
  };

  const fetchCategories = async () => {
    const response = await api.get(`/app/v1/pos/category?include_deleted=False&pageNumber=&pageSize=`);
    const categoryDetails: CarDetailState[] = response.data.category_details;
    setCategories(categoryDetails);

    if (categoryDetails.length > 0) {
      const firstCategoryId = categoryDetails[0]._id.$oid;
      setActiveCategoryId(firstCategoryId);
      // Don't filter here - let the useEffect handle it
    }
  };

  const fetchCustomerData = async () => {
    const response = await api.get(`/app/v1/pos/shopping_cart/${customerId}`);
    console.log("........",response)
    const carDetail = response.data.result[0];
    setCustomerData(carDetail);
  };

  const filterProductsByCategory = (categoryId: string) => {
    const filtered = orderlist.filter((item) => item.category_id === categoryId);
    setFilteredProducts(filtered);
  };

  const handleCategoryChange = (categoryId: string) => {
    setActiveCategoryId(categoryId);
    // The useEffect will handle the filtering automatically
  };

  // Add a function to show all products
  const showAllProducts = () => {
    setActiveCategoryId(null);
    setFilteredProducts(orderlist);
  };

  return {
    orderlist,
    categories,
    customerData,
    activeCategoryId,
    filteredProducts,
    customerId,
    handleCategoryChange,
    showAllProducts,
  };
};
